__turbopack_context__.v({
  "active": "lxsqpW_active",
  "count": "lxsqpW_count",
  "error": "lxsqpW_error",
  "root": "lxsqpW_root",
  "secondary": "lxsqpW_secondary",
  "tab": "lxsqpW_tab",
  "tabsList": "lxsqpW_tabsList",
  "text": "lxsqpW_text",
});
